module.exports = __webpack_public_path__ + "static/media/AnuujinC.1eebf5de.jpg";